<div class="col-md-12 col-md-offset-3">

  <h2>Please sign in</h2>
  <h5>The content you are trying to access is available only to users who are logged in.</h5>
  <br />
  <div>
    To access content exclusive to EBU Members, Associates, expert groups and/or event participants, you must be logged into ebu.ch.
    <br /><br />
    If you don't have an account on ebu.ch, you can <a href="https://sso.ebu.ch/auth/XUI/#/new-user/" target="_blank">register here</a>.
    <br />
    If you belong to an EBU Member, Associate or Approved Participant, be sure to use your professional email address in order to gain access to right services.
    <br />
    After you’ve submitted the form, check your email and click on the link you’ve received to activate your account.
    <br />
    As soon as you activate your account, you can use it to log on to all EBU websites.
  </div>

  <br />
  <form name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
    <div class="form-group">
      <button class="btn btn-primary">Login with EBU SSO</button>
    </div>
  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.html